import React from 'react';
import './Problems.css';

function Problems() {
  const problems = [
    { icon: '📝', title: 'Desorden de órdenes', description: 'Papeles perdidos y falta de seguimiento' },
    { icon: '❌', title: 'Técnicos sin información', description: 'No saben qué hacer ni dónde ir' },
    { icon: '📄', title: 'Fichas de trabajo manuales', description: 'Pérdida de tiempo y errores' },
    { icon: '📊', title: 'Programación en Excel', description: 'Difícil de actualizar y compartir' },
    { icon: '🔍', title: 'Sin control', description: 'No sabes qué técnico hizo cada trabajo' }
  ];

  return (
    <section className="problems section">
      <div className="container">
        <h2 className="section-title">¿Tienes alguno de estos problemas?</h2>
        <p className="section-subtitle">
          Sabemos lo frustrante que es gestionar un equipo técnico sin las herramientas adecuadas
        </p>
        <div className="problems-grid">
          {problems.map((problem, index) => (
            <div key={index} className="problem-card">
              <div className="problem-icon">{problem.icon}</div>
              <h3 className="problem-title">{problem.title}</h3>
              <p className="problem-description">{problem.description}</p>
            </div>
          ))}
        </div>
        <div className="solution-banner">
          <h3>✅ Nosotros lo solucionamos</h3>
          <p>Con un sistema completo, fácil de usar y diseñado para empresas de servicio técnico</p>
        </div>
      </div>
    </section>
  );
}

export default Problems;
